/* assets/whatsapp-popup.js */
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    const popup = document.getElementById('whatsapp-popup');
    const btn = document.getElementById('whatsapp-btn');
    const textBox = document.getElementById('whatsapp-textbox');

    if (!popup || !btn) return;

    // Entrance animation class
    setTimeout(() => {
      popup.classList.add('ready');
    }, 150);

    // Optional: clicking the text box triggers WhatsApp (already handled via HTML)
    if (textBox) {
      textBox.addEventListener('click', () => {
        // nothing special needed — the <a> handles navigation
      });
    }

    // Button click also handled by <a> link — no JS needed
  });
})();
